import { forwardRef } from 'react'
import type { ButtonHTMLAttributes, ReactNode } from 'react'
import classNames from 'classnames'
import Spinner from '@/components/spinner'
import styles from './style.module.css'

type Variant = 'danger' | 'ghost' | 'outline' | 'primary' | 'secondary' | 'success'
type Size = 'lg' | 'md' | 'sm'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  size?: Size
  isLoading?: boolean
  block?: boolean
  iconLeft?: ReactNode
  iconRight?: ReactNode
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      block = false,
      children,
      className,
      disabled,
      iconLeft,
      iconRight,
      isLoading = false,
      size = 'md',
      type = 'button',
      variant = 'primary',
      ...rest
    },
    ref,
  ) => (
    <button
      ref={ref}
      type={type}
      className={classNames(styles.button, styles[variant], styles[size], className, {
        [styles.block]: block,
      })}
      disabled={disabled || isLoading}
      {...rest}
    >
      {isLoading ? <Spinner size={16} /> : iconLeft}
      {children ? <span className={styles.label}>{children}</span> : null}
      {isLoading ? null : iconRight}
    </button>
  ),
)

Button.displayName = 'Button'

export default Button
